import { getS3PresignedUrls } from '../../../lib/restUtils';

const apiUrl = '/api';
// const API_VERSION = 'v2'; // for bender
const API_VERSION = 'v1'; // for dev connectivity

// eslint-disable-next-line import/prefer-default-export
export const apiGetPresignedUrl = (): Promise<string> => {
  // http://dashcommons.dashapi.dev.gogoair.com/v1/accounts/<accountId>/releaseNotesGETUrl
  const apiURL = `${apiUrl}/${API_VERSION}/regulatoryMatrix`;
  return getS3PresignedUrls(apiURL);
};
